import React from 'react';
import { Popup } from "react-leaflet";

export default function ConsolTooltip({ item, mapType }) {

  // Ensure that we have a mappedFullAddress as its referenced in the tooltip templates
  if((!item.address || !item.address.mappedFullAddress) && (item.mappedFullAddress || (item.address && item.address.label))) {
	  
	  if(!item.address) item.address = {};
	  
	  if(item.mappedFullAddress) item.address.mappedFullAddress = item.mappedFullAddress;
	  if(item.address.label) item.address.mappedFullAddress = item.address.label;
  }

  // For boots on the map marker type order, just use marker type boots on tooltip
  if(mapType == 'boots' && item.markerType == "order") {
	  return <MarkerTypeBootsOn item={item} />;
  }	
	
  if (item.markerType == "base") {
    return <MarkerTypeBase item={item} />;
  } else if (item.markerType == "companion") {
    return <MarkerTypeCompanion item={item} />;
  } else if (item.markerType == "order") {
    return <MarkerTypeOrder item={item} />;
  } else if (item.markerType == "boots_on") {
    return <MarkerTypeBootsOn item={item} />;
  } else if (item.markerType == "boots_on_stale") {
    return <MarkerTypeBootsOnStale item={item} />;
  } else if (item.markerType == "clash_order") {
    return <MarkerTypeClashOrder item={item} />;
  } else if (item.markerType == "supplierSelected") {
    return <MarkerTypeSupplierSelected item={item} />;
  } else if (item.markerType == "supplier") {
    return <MarkerTypeSupplier item={item} />;
  }

  return null;
}

function MarkerTypeBase({ item }) {
  return (
    <Popup>
      <p className="marker-text">
        <label>Order No</label>: {item.orderId}
        <br />
        <label>Service Period</label>: {item.hirePeriod}
        <br />
        <label>Mapped Address</label>: {item.address.mappedFullAddress} ({item.lat}
        ,&nbsp;
        {item.lng})
      </p>
    </Popup>
  );
}

function MarkerTypeCompanion({ item }) {
  return (
    <Popup>
      <p className="marker-text">
        <label>Supplier</label>: {item.supplierName}
        <br />
        <label>Contract #</label>: {item.contractRefId}
        <br />
        <label>Qty of Work in Progress</label>: {item.allocQty}
        <br />
        <label>Mapped Address</label>: {item.address.mappedFullAddress} ({item.lat}
        ,&nbsp;
        {item.lng}&nbsp;&nbsp;&nbsp;{item.relevanceStr})<br />
        <label>Distance from Order</label>: {item.distanceFromOrder} KM
      </p>
    </Popup>
  );
}

function MarkerTypeOrder({ item }) {
  return (
    <Popup>
      <p className="marker-text">
        <label>Order No</label>: {item.orderId}
        <br />
        <label>Service Period</label>: {item.hirePeriod}
        <br />
        <br />
        <label>Mapped Address</label>: {item.address.mappedFullAddress} ({item.lat}, {item.lng})
      </p>
    </Popup>
  );
}

function MarkerTypeBootsOn({ item }) {
  return (
    <Popup>
      <p className="marker-text">
        <label>Order No</label>: <a href={item.url}>{item.orderId}</a>
        <br />
        <StandardOrderTooltip item={item} />
      </p>
    </Popup>
  );
}

function MarkerTypeBootsOnStale({ item }) {
  return (
    <Popup>
      <p className="marker-text">
        <label>Order No</label>: <a href={item.url}>{item.orderId}</a>
        <br />
        <StandardOrderTooltip item={item} />
      </p>
    </Popup>
  );
}

function MarkerTypeClashOrder({ item }) {
  return (
    <Popup>
      <p className="marker-text">
        <OrdersAtThisLocation item={item} />
        <br />
        <label>Example Order No</label>: <a href={item.url}>{item.orderId}</a>
        <br />
        <StandardOrderTooltip item={item} />
      </p>
    </Popup>
  );
}

function MarkerTypeSupplierSelected({ item }) {
  return (
    <Popup>
      <p className="marker-text">
        <label>Supplier</label>: {item.supplierName}
        <br />
        <label>Contract #</label>: {item.contractRefId}
        <br />
        <label>Qty of Work in Progress</label>: {item.allocQty}
        <br />
        <label>Mapped Address</label>: {item.address.mappedFullAddress} ({item.lat}
        ,&nbsp;
        {item.lng}&nbsp;&nbsp;&nbsp;
        <span dangerouslySetInnerHTML={{ __html: item.relevanceStr }} />)
        <br />
        <label>Distance from Order</label>: {item.distanceFromOrder} KM
      </p>
    </Popup>
  );
}

function MarkerTypeSupplier({ item }) {
  return (
    <Popup>
      <p className="marker-text">
        {item.address.mappedFullAddress}
        <br />({item.lat}, {item.lng})
      </p>
    </Popup>
  );
}

export function StandardOrderTooltip({ item }) {
  return (
    <span>
      <label>Status</label>: {item.status}
      <br />
      <label>Company</label>: {item.company}
      <br />
      <label>Service Period</label>: {item.hirePeriod}
      <br />
      <label>Location</label>: {item.address.mappedFullAddress}
      <br />
      <label>GPS</label>: {item.lat}, {item.lng}&nbsp;&nbsp;&nbsp;
      <span dangerouslySetInnerHTML={{ __html: item.relevanceStr }} />
      <br />
      <br />
      <label>On-site</label>: <span dangerouslySetInnerHTML={{ __html: item.orderSiteVisits }} />
    </span>
  );
}

export function OrdersAtThisLocation({ item }) {
  return (
    <span>
      <label>Orders At This Location: </label>
      <span dangerouslySetInnerHTML={{ __html: item.orderIdsLink }} />
      &nbsp;&nbsp;&nbsp;
      <span>[&nbsp;</span>
      <span dangerouslySetInnerHTML={{ __html: item.bootsOnLink }} />
      <span>&nbsp;/&nbsp;</span>
      <span dangerouslySetInnerHTML={{ __html: item.bootsOnStaleLink }} />
      <span>&nbsp;/&nbsp;</span>
      <span dangerouslySetInnerHTML={{ __html: item.noBootsLink }} />
      <span>&nbsp;]</span>
    </span>
  );
}
